export enum AnalyticsEventName {
  INVESTOR_APP_LOADED = 'investor_app_loaded',
  INVESTOR_APP_FAILED = 'investor_app_failed',
  INVESTOR_PAGE_VIEWED = 'investor_page_viewed',
  INVESTOR_CTA_CLICKED = 'investor_cta_clicked',
  INVESTOR_CONTROL_CHANGED = 'investor_control_changed',
  INVESTOR_API_BACKEND = 'investor_api_backend',
  INVESTOR_ENTRY_FAILED = 'investor_entry_failed',
  INVESTOR_SESSION_FAILED = 'investor_session_failed',
  INVESTOR_CHECKOUT_SUCCEEDED = 'investor_checkout_succeeded',
  INVESTOR_CHECKOUT_FAILED = 'investor_checkout_failed',
  INVESTOR_CHECKOUT_CLOSED = 'investor_checkout_closed',
}
